export default __webpack_public_path__ + "static/web-logo-3-a185839832305a71a12cf50fa9649ace.webp";